<button
  class="btn btn-warning btn-ico"
  [ngbTooltip]="'PHONE_CALLS_FINDER_BUTTON.PHONE_CALLS' | translate"
  container="body"
  (click)="open()"
>
  <i class="fas fa-phone-volume"></i>
</button>
